
import {
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  INICIA_DASHBOARD_PRESENCA,
  BUSCA_DASHBOARD_PRESENCA,
  INICIA_DASHBOARD_PRESENCA_SUCESSO,
  BUSCA_DASHBOARD_PRESENCA_SUCESSO
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ---------------------------------- Actions Presença -------------------------------*/

export const iniciaDashboardPresenca = () => {
  return {
    type: INICIA_DASHBOARD_PRESENCA
  }
}

export const buscaDashboardPresenca = (idLocalControlado) => {
  return {
    type: BUSCA_DASHBOARD_PRESENCA,
    payload: idLocalControlado
  }
}

/*#############################################################################################*/
/* ---------------------------------- Actions Respostas Presença -------------------------------*/

export const iniciaDashboardPresencaSucesso = (inicioDashboardPresenca) => {
  return {
    type: INICIA_DASHBOARD_PRESENCA_SUCESSO,
    payload: inicioDashboardPresenca
  }
}

export const buscaDashboardPresencaSucesso = (dashboardPresenca) => {
  return {
    type: BUSCA_DASHBOARD_PRESENCA_SUCESSO,
    payload: dashboardPresenca
  }
}

/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};